import TextInput from '@/components/refinedev/TextInput';
import {UseDialogStateReturn} from '@/hooks/useDialogState';
import {FormProvider, useForm, UseFormProps} from 'react-hook-form';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
} from '@/shadcn_components/ui/dialog';
import {Node, useReactFlow} from '@xyflow/react';
import {SaveButton} from '@/components/refinedev/action_buttons';
import {ReactNode, useCallback} from 'react';
import {v4 as uuidv4} from 'uuid';
import {newNode} from './nodes/utils';

export type NodeCreateDialogProps = {
  title?: string;
  children?: ReactNode;
  dialogState: UseDialogStateReturn;
  onSubmit?: (data: any) => Promise<void>;
  closeWhenSubmit?: boolean;
  formProps?: UseFormProps<any>;
  transformBeforeSave?: (data: any) => any;
};

export const NodeCreateDialog = (props: NodeCreateDialogProps) => {
  const {dialogState, title, formProps, children, onSubmit, closeWhenSubmit = true} = props;

  const {addNodes} = useReactFlow();

  const form = useForm(formProps);

  const {handleSubmit} = form;

  const onSubmitDefault = useCallback(
    async submittedData => {
      const data = props.transformBeforeSave?.(submittedData) || submittedData;

      const nodeData = newNode({
        type: dialogState.extraData.type,
        position: dialogState.extraData.position,
        data,
      });

      if (!onSubmit) {
        console.log('submitted', dialogState, data);
        addNodes(nodeData);
      } else {
        await onSubmit?.(nodeData);
      }

      if (closeWhenSubmit) dialogState.closeDialog();
    },
    [onSubmit, dialogState, closeWhenSubmit, addNodes],
  );

  function onOpenChange(open) {
    console.log('dialog open', open);
    if (!open) form.reset();
    dialogState.setOpen(open);
  }

  return (
    <Dialog open={dialogState.open} onOpenChange={onOpenChange}>
      <DialogContent>
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmitDefault)}>
            <DialogHeader>
              <DialogTitle>{title}</DialogTitle>
              <DialogDescription></DialogDescription>
            </DialogHeader>
            <div className="overflow-y-auto max-h-[calc(100vh-200px)] scroll px-2">{children}</div>
            <DialogFooter>
              <SaveButton type="button" onClick={handleSubmit(onSubmitDefault)} />
            </DialogFooter>
          </form>
        </FormProvider>
      </DialogContent>
    </Dialog>
  );
};
